import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'concatInlineStyles',
  standalone: true,
})
export class ConcatInlineStylesPipe implements PipeTransform {
  transform(inlineStyles: (string | string[] | null | undefined | boolean)[]) {
    return inlineStyles
      .reduce<string>((all, definition) => {
        if (!definition || definition === 'false') return all;
        if (Array.isArray(definition)) definition = definition.join(' ');
        if (all && !/;\s*$/.test(all)) all += ';';
        return all + (all ? ' ' : '') + String(definition);
      }, '')
      .trim()
      .replace(/\s+/g, '');
  }
}
